import React from "react";
import { AnimatePresence, motion } from "framer-motion";

function ScrollImages({ images, ...props }) {
    const gap = 10;
    return (
        <AnimatePresence>
            <motion.div
                initial={{
                    x: "0%",
                    y: "-50%",
                }}
                animate={{
                    x: "-50%",
                    y: "-50%",
                }}
                transition={{
                    repeat: Infinity,
                    duration: 17,
                    ease: "linear",
                }}
                {...props}
            >
                <>
                    {images.map((block, index) => (
                        <React.Fragment key={index}>{block}</React.Fragment>
                    ))}
                </>
            </motion.div>
        </AnimatePresence>
    );
}

export { ScrollImages };
